module.exports = __webpack_public_path__ + "static/media/15.8479fdc0.JPG";